import { CharacterCardGridConfig, UseCharacterCardGridConfig } from "@/components/Character/CharacterCardGridConfig/types";

const DEFAULT_COL_WIDTH = 160;
const DEFAULT_COL_GAP = 12;

const defaultGridConfig: CharacterCardGridConfig = {
  colWidth: DEFAULT_COL_WIDTH,
  colGap: DEFAULT_COL_GAP,
  cardLayout: "square",
};

const useCharacterCardGridConfig: UseCharacterCardGridConfig = () => defaultGridConfig;

export default useCharacterCardGridConfig;
